import { Box, Button, Grid, Typography } from '@mui/material';
import React from 'react';
import styles from './EmptyTable.module.css';
import EmptyState from 'assets/images/empty-state.svg';
import { docGeniusPalette } from 'styles/partials/colors';

type Props = {
  title: string;
  imgSrc?: string;
  subtitle?: string;
  buttonText?: string;
  onClick?: () => void;
  buttonComponent?: JSX.Element;
  smallImage?: boolean;
};

const EmptyTable: React.FC<Props> = ({ title, imgSrc, subtitle, buttonText, onClick, buttonComponent, smallImage }) => (
  <Grid container direction='column' justifyContent='center' alignItems='center' className={styles.container}>
    <img src={imgSrc || EmptyState} className={smallImage ? styles.smallImage : styles.emptyState} alt='Empty table' />
    <Typography
      fontSize={'24px'}
      fontWeight={'500'}
      lineHeight={'32px'}
      marginTop={'24px'}
      color={docGeniusPalette.neutralGray}
    >
      {title}
    </Typography>
    {!!subtitle && (
      <Typography fontSize={'16px'} lineHeight={'24px'} color={docGeniusPalette.neutralGray}>
        {subtitle}
      </Typography>
    )}
    {!!buttonText && (
      <Button variant='contained' sx={{ textTransform: 'none', marginTop: '24px' }} onClick={onClick}>
        {buttonText}
      </Button>
    )}

    {!!buttonComponent && <Box marginTop='24px'>{buttonComponent}</Box>}
  </Grid>
);

export default EmptyTable;
